module.exports = __webpack_public_path__ + "img/close.97d7f081.svg";